import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { map, catchError, of } from 'rxjs';

export const courseGuard: CanActivateFn = (route, _state) => {
  const router = inject(Router);
  const api = inject(ApiService);
  const courseId = Number(route.paramMap.get('id'));

  return api.show('tlh-courses', courseId, { only: 'id' }).pipe(
    map(() => true),
    catchError(() => {
      router.navigate(['/dashboard']);
      return of(false);
    }),
  );
};
